<template>
  <div class="mb-7">

    <dlnkmessages-new-message
        :member_id="member_id"
        :member_name="member_name"
        :group_id="''">
    </dlnkmessages-new-message>

    <div class="mb-2">
      <h3>Membres</h3>
    </div>

    <div class="text-md-right mb-3">
      <!-- SEARCH -->
      <input  class="form-control-sm w-100 border"
              v-on:keyup="search_members" type="text" placeholder="Rechercher ..."
              v-model="query">
      <!-- END SEARCH -->
    </div>

    <!-- Pagination -->
    <div class="mt-2">
      <dlnkpagination
          :page="page"
          :page_count="page_count"
          :display_light="true"
          @next_page="next_page()"
          @prev_page="prev_page()"
          @set_page="set_page($event)">
      </dlnkpagination>
    </div>


    <article class="mb-3"
             v-for="member in members"
             :key="member.id">
    <div class="media align-items-center text-inherit">
        <div class="avatar mr-3">
          <img class="avatar avatar-circle" :src="member.photo_url" alt="Member Avatar">
        </div>
        <div class="media-body">
          <h4 class="h6 mb-0"><a class="text-inherit" href="#">{{member.name}}</a></h4>

          <a :href="'/module/dlnkchat/chat?id=' + member.id"><i class="fas fa-comments"></i></a>

          <a href="javascript;" @click.prevent="send_message(member.id, member.name)"><i class="fas fa-envelope"></i></a>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
    export default {
      props: ['group_id'],
      data: function () {
        return {
          page: Number,
          page_count: Number,
          members: [],
          member_id: 0,
          member_name: "",
          query: '',
          order_by: 'name',
          order_direction: 'asc',
        }},

      mounted() {
        console.log('Component mounted.');
        this.page = 1
        this.page_count = 1
        this.get_members();
      },

      watch: {
        page: function (new_val, old_val) {
          if (new_val < 1) {
            this.page = 1
          }
          if (new_val > this.page_count) {
            this.page = this.page_count
          }
          this.get_members()
        },
      },

      methods: {
        get_members: function () {
          const _this = this

          const url = '/modules/daentreprise/actions/members.php?page=' + _this.page;

          axios.get( url +
              '&group_id='        + _this.group_id +
              '&query='           + _this.query +
              '&order_by='        + _this.order_by +
              '&order_direction=' + _this.order_direction)
              .then(function (response) {
                _this.members = response.data.members
                _this.page_count = response.data.page_count
              })
              .catch(function (error) {
                console.log(error);
              })
              .then(function () {
                    // always executed
                  }
              );
        },

        set_page: function (page) {
          page = parseInt(page)
          this.page = page
        },

        next_page: function () {
          this.page++
        },

        prev_page: function () {
          this.page--
        },

        search_members() {
          this.get_members();
        },

        send_message(member_id, member_name) {
          this.member_id = member_id;
          this.member_name = member_name;

          $('#new_message_modal').modal('show');
        }
      },
    }
</script>

